import type { OverlayProps } from '@allesauto/core/overlay';
import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '@/store/redux';
import { closeOverlay } from '@/store/redux/actions/app';

// workaround import path due to webpack bug https://github.com/webpack/webpack/issues/13865
const Overlay = dynamic<OverlayProps>(
  () => import('../../../../../packages/allesauto-core/src/lib/overlay')
);

const DynamicOverlayContainer = () => {
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    function closeOnRouteChange() {
      dispatch(closeOverlay());
    }

    router.events.on('routeChangeStart', closeOnRouteChange);

    return () => {
      router.events.off('routeChangeStart', closeOnRouteChange);
    };
  }, [dispatch, router]);

  const overlayProps = useSelector(
    (state: RootState) => state.app.overlayProps
  );

  const showOverlay = useSelector((state: RootState) => state.app.showOverlay);

  const whiteLabelIntegrationSlug = useWhiteLabel()?.subdomain || undefined;

  return (
    <Overlay
      {...overlayProps}
      open={showOverlay}
      onClose={() => dispatch(closeOverlay())}
      whiteLabelIntegrationSlug={whiteLabelIntegrationSlug}
    >
      {overlayProps.children}
    </Overlay>
  );
};

export default DynamicOverlayContainer;
